import { Checkbox } from '@synoptic/ui-kit/checkbox/checkbox.tsx';
import { FC } from 'react';
import {
  actionLink,
  checkbox,
  formInfoBlock,
  formInfoDescription,
  formInfoTitle,
} from '@/components/streams/stream-form/stream-form.css.ts';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';

export const AcceptTerms: FC<{
  accepted: boolean;
  setAccepted: (accepted: boolean) => void;
}> = ({ accepted, setAccepted }) => {
  return (
    <div>
      <div className={formInfoBlock}>
        <h3 className={formInfoTitle}>Agree to Terms and Conditions</h3>
        <p className={formInfoDescription}>
          By submitting this form, you confirm that you have read and agree to
          Synoptic’s{' '}
          <Link className={actionLink} to={paths.termsOfUse} target={'_blank'}>
            Terms and Conditions
          </Link>
          , including the refund policy and any applicable guidelines for making
          changes to it.
        </p>
      </div>
      <label className={checkbox}>
        <Checkbox checked={accepted} onCheckedChange={setAccepted} />
        <span>
          I have read and agree to the platform’s{' '}
          <Link className={actionLink} to={paths.termsOfUse} target={'_blank'}>
            Terms and Conditions
          </Link>
          , including the refund policy.
        </span>
      </label>
    </div>
  );
};
